<template>
  <el-submenu :index="data.title">
    <template slot="title">
      <slot></slot>
      <i
        class="icon" style="margin-right: 10px;font-size: 20px;color: #30c0cd;"
        v-html="data.icon"></i>
      <span slot="title">{{data.title}}</span>
    </template>
    <template v-for="item in data.children">
      <el-menu-item-group v-if="item.type === 'group'">
        <template slot="title">{{item.title}}</template>
        <a :href="'/#' + groupItem.path" v-for="groupItem in item.children" :key="groupItem.title">
          <el-menu-item :index="groupItem.name">{{groupItem.title}}</el-menu-item>
        </a>
      </el-menu-item-group>
      <el-submenu v-else-if="item.type === 'submenu'" :index="item.title">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>{{item.title}}</span>
        </template>
        <base-submenu :data="item"></base-submenu>
      </el-submenu>
      <a :href="'/#' + item.path" v-else>
        <el-menu-item :index="item.name" style="padding-left: 20px;display: flex;margin-left: 20px">
          <i class="icon" style="margin-right: 10px;font-size: 20px" v-html="item.icon"></i>
          <span slot="title">{{item.title}}</span>
        </el-menu-item>
      </a>
    </template>
  </el-submenu>
</template>
<script>
export default {
  name: 't-submenu',
  props: {
    data: Object
  }
};
</script>
<style lang="scss">
  .el-menu .el-submenu__title i {

  }

  .menu-tiem-i {
    font-size: 18px;
    margin-right: 5px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #11a5fc;
    margin: 17.5px 5px 17.5px 0;
  }

  .menu-tiem-text {
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../../src/layout/components/submenu/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../../src/layout/components/submenu/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../../src/layout/components/submenu/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-private-submenu')
  export default {
    name: 'private-submenu', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'private-submenu': require('%path').default,
       */
      /*start:import components file*/
'base-account-info': require('./../../../base-components/account-info/index.vue').default,
       'base-back': require('./../../../base-components/back/index.vue').default,
       'base-blackHandle': require('./../../../base-components/blackHandle/index.vue').default,
       'base-bottomFloat': require('./../../../base-components/bottomFloat/index.vue').default,
       'base-card-header': require('./../../../base-components/card-header/index.vue').default,
       'base-carDriverInfo': require('./../../../base-components/carDriverInfo/index.vue').default,
       'base-cascader-select-on-click': require('./../../../base-components/cascader-select-on-click/index.vue').default,
       'base-check-all': require('./../../../base-components/check-all/index.vue').default,
       'base-cropper': require('./../../../base-components/cropper/index.vue').default,
       'base-datetimerange': require('./../../../base-components/datetimerange/index.vue').default,
       'base-dialog': require('./../../../base-components/dialog/index.vue').default,
       'base-empty': require('./../../../base-components/empty/index.vue').default,
       'base-export': require('./../../../base-components/export/index.vue').default,
       'base-filter': require('./../../../base-components/filter/index.vue').default,
       'base-image-carousel': require('./../../../base-components/image-carousel/index.vue').default,
       'base-img-base': require('./../../../base-components/img-base/index.vue').default,
       'base-img-viewer': require('./../../../base-components/img-viewer/index.vue').default,
       'base-key-value': require('./../../../base-components/key-value/index.vue').default,
       'base-my-column': require('./../../../base-components/my-column/index.vue').default,
       'base-number-input': require('./../../../base-components/number-input/index.vue').default,
       'base-plate': require('./../../../base-components/plate/index.vue').default,
       'base-quarter-datepicker': require('./../../../base-components/quarter-datepicker/index.vue').default,
       'base-simple-menu': require('./../../../base-components/simple-menu/index.vue').default,
       'base-yearrange': require('./../../../base-components/yearrange/index.vue').default,
       'business-account-info': require('./../../../business-components/account-info/index.vue').default,
       'business-alarm-badge': require('./../../../business-components/alarm-badge/index.vue').default,
       'business-car-type-cascader': require('./../../../business-components/car-type-cascader/index.vue').default,
       'business-data-export-dialog': require('./../../../business-components/data-export-dialog/index.vue').default,
       'business-Multi-table': require('./../../../business-components/Multi-table/index.vue').default,
       'business-newTable-pagination': require('./../../../business-components/newTable-pagination/index.vue').default,
       'business-node-cascader': require('./../../../business-components/node-cascader/index.vue').default,
       'business-org-cascader': require('./../../../business-components/org-cascader/index.vue').default,
       'business-page-picture-content': require('./../../../business-components/page-picture-content/index.vue').default,
       'business-page-picture-contentV2': require('./../../../business-components/page-picture-contentV2/index.vue').default,
       'business-page-picture-contentV3': require('./../../../business-components/page-picture-contentV3/index.vue').default,
       'business-page-sub-title': require('./../../../business-components/page-sub-title/index.vue').default,
       'business-page-tabs': require('./../../../business-components/page-tabs/index.vue').default,
       'business-page-title': require('./../../../business-components/page-title/index.vue').default,
       'business-table-dialog': require('./../../../business-components/table-dialog/index.vue').default,
       'business-table-pagination': require('./../../../business-components/table-pagination/index.vue').default,
       'business-update-confirm-status': require('./../../../business-components/update-confirm-status/index.vue').default,
       'business-update-deal-status': require('./../../../business-components/update-deal-status/index.vue').default,
       /*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>